import { Organizations } from '../../types';

export type OrganizationShared = Organizations.Organization;
export const OrganizationsPages = Organizations.Pages;
